import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const DELETE_CONFI_COST_RESET = 'DELETE_CONFI_COST_RESET';
export const DELETE_CONFI_COST_LOADING = 'DELETE_CONFI_COST_LOADING';
export const DELETE_CONFI_COST_SUCCESS = 'DELETE_CONFI_COST_SUCCESS';
export const DELETE_CONFI_COST_REJECT = 'DELETE_CONFI_COST_REJECT';

//* ACTIONS ------------------------------------------------
export const deleteConfiCostReset = () => ({ type: DELETE_CONFI_COST_RESET });
export const deleteConfiCostLoading = () => ({ type: DELETE_CONFI_COST_LOADING });
export const deleteConfiCostSuccess = (payload) => ({ type: DELETE_CONFI_COST_SUCCESS, payload });
export const deleteConfiCostReject = (payload) => ({ type: DELETE_CONFI_COST_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const deleteConfiCostRequest = async (data = {}, getState) => {
    const options = await withToken({
        method: Methods.DELETE,
    }, getState);
    return request(`/Costs/web/DeleteCosts?id=${data.id ?? data}`, options);
};
